export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

/** Admin emails that can add/edit clients (Lloyd + Missy) */
export const ADMIN_EMAILS: string[] = [
  'admin@assistdevelopmentaltherapy.com',
  'hello@assistdevelopmentaltherapy.com',
  'lloyd.everett1@gmail.com',
];

/** Approved team emails that can access internal pages */
export const APPROVED_TEAM_EMAILS: string[] = [
  'admin@assistdevelopmentaltherapy.com',
  'hello@assistdevelopmentaltherapy.com',
  'lloyd.everett1@gmail.com',
  'sj@assistdevelopmentaltherapy.com',
  'jade@assistdevelopmentaltherapy.com',
  'maddy@assistdevelopmentaltherapy.com',
  'sophia@assistdevelopmentaltherapy.com',
  'emma@assistdevelopmentaltherapy.com',
];
